import { version as versionRaw } from "../../static/version.json";

const apiUrl = window.g.apiUrl;
const wsUrl = window.g.wsUrl;
const ossBaseUrl = window.g.ossBaseUrl;
const arms = window.g.arms; // ARMS开关
const armsEnvironment = window.g.armsEnvironment; // ARMS环境 'prod'|'gray'|'pre'|'daily'|'local'

// 会话闲置超时自动锁定（分钟），<=0 或未配置表示不启用
const sessionIdleTimeoutRaw = Number(window.g.sessionIdleTimeout);
const sessionIdleTimeout = sessionIdleTimeoutRaw > 0 ? sessionIdleTimeoutRaw : 0;

const version = versionRaw;

export { apiUrl, wsUrl, ossBaseUrl, version, arms, armsEnvironment, sessionIdleTimeout };
